import React from 'react';
import PropTypes from 'prop-types';
import { createCustomPropType, isNumeric, isUuid } from '../../../js/app/react/validators';

const MobileEditGoalButtonView = ({
  onEditGoal, goalType, goalId, clientId,
}) => (
  <div className="mobile-edit-goal-button">
    <button
      className="mobile-consumer-overview-logout"
      type="button"
      onClick={onEditGoal(clientId, goalType, goalId)}
    >
      <i className="mobile-consumer-overview-logout-i far fa-edit" />
      Edit Goal
    </button>
  </div>
);
MobileEditGoalButtonView.propTypes = {
  onEditGoal: PropTypes.func.isRequired,
  goalType: PropTypes.string.isRequired,
  goalId: createCustomPropType(isUuid).isRequired,
  clientId: createCustomPropType(isNumeric).isRequired,
};

export default MobileEditGoalButtonView;
